export default {
    state: {
        width: null,
        height: null,
        isXs: false
    },
    mutations: {
        setWindowWidth(state, payload) {
            state.width = payload
            state.isXs = state.width < 600
        },
        setWindowHeight(state, payload) {
            state.height = payload
        },
    },
    actions: {
        setWindowWidth({ commit }, payload) {
            commit('setWindowWidth', payload)
        },
        setWindowHeight({ commit }, payload) {
            commit('setWindowHeight', payload)
        }
    }
}